import { User } from "../api/typings/Users";
import { Nullable } from "../@typings/typings";

export class FormatPhone {
  static toDigits(phone: string): Nullable<number> {
    const digits = phone.match(/\d+/gm);
    if (!digits) return null;
    return parseFloat(phone.match(/\d+/gm)!.join(""));
  }
}

export function formatUsersPhone(users: Record<string, User>) {
  if (users) {
    Object.keys(users).forEach((key) => {
      if (users[key].phone == null) {
        users[key].phone = "";
      } else {
        users[key].phone = `+${users[key].phone.toString()}`;
      }
      const phones = users[key].additional_phones;
      if (phones) {
        // todo добавить в форматирование "+" когда бэкенд будет присылать без него
        users[key].additional_phones = phones.map((phone) => `${phone}`);
      }
    });
  }
}
